import {config, isApp} from './utils.js';
import {get} from './utils/ajax.js';
import {productUrl, userUrl} from './utils/url-helper.js';

const getHighlights = async() =>
		await get(`/api/v5/highlights`);

const setHighlights = async () => {
	const highlightsData = await getHighlights();
	const highlightsContainer = document.querySelector('.highlights-container');
	if (isApp() || !highlightsContainer || !highlightsData ||
			highlightsData.length === 0)
	{
		removeHighlightsSection();
		return;
	}
	highlightsData.forEach(highlightData => renderHighlight(highlightData));
	setCarouselBtns(highlightsContainer);
};

const setCarouselBtns = (highlightContainer) => {
	if (!highlightContainer) return;
	const prevBtn = highlightContainer.querySelector('.highlights-nav-prev');
	const nextBtn = highlightContainer.querySelector('.highlights-nav-next');
	const carousel = highlightContainer.querySelector('.highlights-carousel');
	if (!prevBtn || !nextBtn || !carousel) return;
	/* Scroll a la izquierda */
	prevBtn.addEventListener('click', () => {
		carousel.scrollBy({
			left: -highlightContainer.offsetWidth,
			behavior: 'smooth'
		});
	});
	/* Scroll a la derecha */
	nextBtn.addEventListener('click', () => {
		carousel.scrollBy({
			left: highlightContainer.offsetWidth,
			behavior: 'smooth'
		});
	});
	/* Deshabilitar botones al llegar al final */
	if (carousel.scrollLeft === 0) {
		prevBtn.setAttribute('disabled', '');
	} else {
		prevBtn.removeAttribute('disabled');
	}
	if (Math.round(carousel.scrollLeft) >=
			carousel.scrollWidth - carousel.offsetWidth) {
		nextBtn.setAttribute('disabled', '');
	} else {
		nextBtn.removeAttribute('disabled');
	}
	carousel.addEventListener('scrollend', () => {
		if (carousel.scrollLeft === 0) {
			prevBtn.setAttribute('disabled', '');
		} else {
			prevBtn.removeAttribute('disabled');
		}
		if (Math.round(carousel.scrollLeft) >=
				carousel.scrollWidth - carousel.offsetWidth) {
			nextBtn.setAttribute('disabled', '');
		} else {
			nextBtn.removeAttribute('disabled');
		}
	});
};

const removeHighlightsSection = () => {
	document.querySelector('.highlights-container')?.remove();
	document.querySelectorAll('[id^="highlight"]').forEach(tmpl =>
			tmpl.remove());
};

const renderHighlight = async (highlightData) => {
	const carousel = document.querySelector('.highlights-carousel');
	const highLightTmpl = document.getElementById(
			`highlight-${highlightData.type}`);
	if (!highLightTmpl || !carousel) return;
	const highlightElement = highLightTmpl.content.cloneNode(true);
	fillHighlightContent(highlightElement, highlightData);
	carousel.appendChild(highlightElement);
};

const fillHighlightContent = (elem, data) => {
	switch (data.type) {
		case 'basic':
			fillBasicHighlight(elem, data);
			break;
		case 'closet':
			fillClosetHighlight(elem, data);
			break;
		case 'collection':
			fillCollectionHighlight(elem, data);;
			break;
		case 'cover':
			fillCoverHighlight(elem, data);;
			break;
		case 'influencers':
			fillInfluencersHighlight(elem, data);
			break;
		default:
			console.warn(`Tipo de highlight no soportado: ${data.type}`);
	}
};

const fillBasicHighlight = (elem, data) => {
	// Color de fondo
	elem.firstElementChild.classList.add(`variant-${data.detail.color}`);
	// Pill
	const pill = elem.querySelector('.pill');
	pill.textContent = data.detail.headline_text;
	// Título
	const title = elem.querySelector('h2');
	title.textContent = data.detail.title;
	// Botón
	const button = elem.querySelector('a');
	button.textContent = data.detail.button_text;
	button.href = data.detail.url;
	if (data.detail.color === 'primary') { // Sólo el primary lleva el botón secundario
		button.classList.replace('button-primary', 'button-secondary');
	}
};

const fillClosetHighlight = (elem, data) => {
	// Color de fondo
	elem.firstElementChild.classList.add(`variant-${data.detail.color}`);
	// Imagen
	if (data.detail.closet_owner.img_url) {
		const image = elem.querySelector('img.closet-img');
		image.src = data.detail.closet_owner.img_url;
	}
	// Pill
	const pill = elem.querySelector('.pill');
	pill.textContent = data.detail.headline_text;
	// Título
	const title = elem.querySelector('h3');
	title.textContent = data.detail.title;
	// Productos
	const productsContainer = elem.querySelector('.products');
	data.detail.products.forEach(product => {
		const productLink = document.createElement('a');
		productLink.href = productUrl(product.permalink);
		const productImg = document.createElement('img');
		productImg.src = product.img_url;
		productLink.appendChild(productImg);
		productsContainer.appendChild(productLink);
	});
	// Botón
	const button = elem.querySelector('a.button');
	button.textContent = data.detail.button_text;
	button.href = data.detail.url;
};

const fillCollectionHighlight = (elem, data) => {
	// Color de fondo
	elem.firstElementChild.classList.add(`variant-${data.detail.color}`);
	// Pill
	const pill = elem.querySelector('.pill');
	pill.textContent = data.detail.headline_text;
	// Título
	const title = elem.querySelector('h3');
	title.textContent = data.detail.title;
	// Subtítulo
	const subtitle = elem.querySelector('.subtitle');
	subtitle.textContent = data.detail.subtitle;
	// Productos
	const productsContainer = elem.querySelector('.products');
	data.detail.products.forEach(product => {
		const productLink = document.createElement('a');
		productLink.href = productUrl(product.permalink);
		const productImg = document.createElement('img');
		productImg.src = product.img_url;
		productLink.appendChild(productImg);
		productsContainer.appendChild(productLink);
	});
	// Botón
	const button = elem.querySelector('a');
	button.textContent = data.detail.button_text;
	button.href = data.detail.url;
};

const fillCoverHighlight = (elem, data) => {
	// Imagen
	elem.querySelector('img').src = data.detail.cover_img_url;
	// Pill
	const pill = elem.querySelector('.pill');
	pill.textContent = data.detail.headline_text;
	// Título
	const title = elem.querySelector('h2');
	title.textContent = data.detail.title;
	// Botón
	const button = elem.querySelector('a');
	button.textContent = data.detail.button_text;
	button.href = data.detail.url;
};

const fillInfluencersHighlight = (elem, data) => {
	// Pill
	const pill = elem.querySelector('.pill');
	pill.textContent = data.detail.headline_text;
	// Título
	const title = elem.querySelector('h3');
	title.textContent = data.detail.title;
	// Influencers
	const influencersContainer = elem.querySelector('.influencers');
	data.detail.influencers.forEach(influencer => {
		const influencerLink = document.createElement('a');
		influencerLink.href = userUrl(influencer.username);
		const influencerImg = document.createElement('img');
		influencerImg.src = influencer.img_url;
		influencerLink.appendChild(influencerImg);
		const influencerName = document.createElement('div');
		influencerName.classList.add('influencer-name', 'caption-md',
				'text-ellipsis');
		influencerName.textContent = influencer.full_name;
		influencerLink.appendChild(influencerName);
		influencersContainer.appendChild(influencerLink);
	});
};

export {setHighlights};